import { create } from 'zustand'

import { devtools } from 'zustand/middleware'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// types
import {
  Labour,
  Schedule,
  AnnouncementsData,
  NotificationData
} from '../types/labourTypes'
import { labourService } from '../services/labourService'
// import moment from 'moment';
import moment from '../momentConfig'

// types
type Store = {
  labourData: Labour
  scheduleData: Schedule
  AnnouncmentsData: AnnouncementsData
  loading: boolean
  error: null
  notificationData: NotificationData
  startWeekDate: any
  endWeekDate: any
  setStartWeekDate: any
  setEndWeekDate: any
  accountDetails: any
  fetchData: (id: number) => void
  schedulefetchData: (Id: number, from: string, to: string) => void
  announcementsfetchData: (
    entityid: number,
    storeid: number,
    corpid: number
  ) => void
  getNotification: (id: number) => void
  updateNotificationStatus: (id) => void
  getNotificationDetails: (id: number) => void
  markallasread: (data) => any
  switchaccount: (email) => any
  startdayofweekdata: any
  getDaysOrder: (id: number) => void
  getTimeClockId: (userId: number) => void
  timeClockData: any
}

const useLabourStore = create(
  devtools<Store>((set, get) => ({
    accountDetails: null,
    labourData: null,
    scheduleData: null,
    notificationData: null,
    AnnouncmentsData: null,
    startdayofweekdata: null,
    loading: false,
    error: null,
    toggleProfile: true,
    startWeekDate: null,
    endWeekDate: null,
    timeClockData: null,
    setStartWeekDate: (data: any) => {
      set((state) => ({ ...state, startWeekDate: data }))
    },
    setEndWeekDate: (data: any) => {
      set((state) => ({ ...state, endWeekDate: data }))
    },

    fetchData: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _labourData = await labourService.fetchData(id)
        set((state) => ({ ...state, labourData: _labourData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    schedulefetchData: async (Id: number, from: string, to: string) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _scheduleData = await labourService.schedulefetchData(
          Id,
          from,
          to
        )
        set((state) => ({ ...state, scheduleData: _scheduleData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    announcementsfetchData: async (
      entityid: number,
      storeid: number,
      corpid: number
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _announcementsData = await labourService.announcementsfetchData(
          entityid,
          storeid,
          corpid
        )
        set((state) => ({
          ...state,
          AnnouncmentsData: _announcementsData?.reverse()
        }))
      } catch (err) {
        set((state) => ({
          ...state,
          error: err.message,
          AnnouncmentsData: null
        }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getNotification: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _notificationData = await labourService.getNotification(id)
        set((state) => ({ ...state, notificationData: _notificationData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getNotificationDetails: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await labourService.getNotificationDetails(id)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    updateNotificationStatus: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await labourService.updateNotificationStatus(id)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    markallasread: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await labourService.markallasread(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    switchaccount: async (email) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _data = await labourService.switchaccount(email)
        set((state) => ({ ...state, accountDetails: _data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getDaysOrder: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _data: any = await labourService.getDaysOrder(id)

        // const test = { ..._data, payPeriodDay: 'friday' }
        // set((state) => ({ ...state, startdayofweekdata: test }))

        set((state) => ({ ...state, startdayofweekdata: _data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getTimeClockId: async (userId) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _data = await labourService.getTimeClockId(userId)
        console.log('timeclock', _data)
        set((state) => ({ ...state, timeClockData: _data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useLabourStore }
